import {
  CLIENTES_ESTADO_FETCH_REQUEST,
  CLIENTES_ESTADO_FETCH_SUCCESS,
  CLIENTES_ESTADO_FETCH_FAILURE,
  CLIENTES_ESTADO_FETCH_RESET,
  CLIENTES_LIST_FETCH_REQUEST,
  CLIENTES_LIST_FETCH_SUCCESS,
  CLIENTES_LIST_FETCH_FAILURE,
  CLIENTES_LIST_FETCH_RESET,
} from "redux/types/clientesTypes";

const initialState = {
  estado: {
    loading: false,
    data: null,
    error: null,
  },
  list: {
    loading: false,
    data: null,
    error: null,
  },
};

const clientesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENTES_ESTADO_FETCH_REQUEST:
      return {
        ...state,
        estado: {
          ...state.estado,
          loading: true,
          error: null,
        },
      };

    case CLIENTES_ESTADO_FETCH_SUCCESS:
      return {
        ...state,
        estado: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case CLIENTES_ESTADO_FETCH_FAILURE:
      return {
        ...state,
        estado: {
          ...state.estado,
          loading: false,
          error: action.payload,
        },
      };

    case CLIENTES_ESTADO_FETCH_RESET:
      return {
        ...state,
        estado: initialState.estado,
      };

    case CLIENTES_LIST_FETCH_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
        },
      };

    case CLIENTES_LIST_FETCH_SUCCESS:
      return {
        ...state,
        list: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case CLIENTES_LIST_FETCH_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.payload,
        },
      };

    case CLIENTES_LIST_FETCH_RESET:
      return {
        ...state,
        list: initialState.list,
      };

    default:
      return state;
  }
};

export default clientesReducer;
